import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { getInvoiceConfigs } from 'api/invoiceConfig/getInvoiceConfigs'
import { invoiceConfigKeyWithParams } from './keys'

export const useInvoiceConfigsQuery = (
  request: Parameters<typeof getInvoiceConfigs>[0]
) => {
  return useQuery({
    queryKey: invoiceConfigKeyWithParams([
      request.page,
      request.pageSize,
      request.companyId,
      request.breakdownLevels,
    ]),
    queryFn: () => getInvoiceConfigs(request),
    placeholderData: keepPreviousData,
  })
}
